import { jsx as _jsx } from "react/jsx-runtime";
import '@styles/webdesktop/stylesheets/instrumentTypeLogo.scss';
import { getInstrumentTypeShortName } from '@shared/utils/Instruments/InstrumentTypes';
import { Typography } from '../Typography/Typography';
import { TypographyLevel } from '../Typography/TypographyLevel';
export const InstrumentTypeLogo = ({ instrumentType, clickable = false, onClick, disabled = false }) => {
    const shortName = getInstrumentTypeShortName(instrumentType);
    const classNames = [
        'instrument-type-logo',
        clickable ? 'clickable' : '',
        disabled ? 'disabled' : '',
        isValidString(shortName) ? shortName.toLowerCase() : 'no-type'
    ];
    const className = classNames.filter(Boolean).join(' ');
    return clickable ? (_jsx("button", { type: "button", className: "instrument-type-logo-button", onClick: onClick, disabled: disabled, children: _jsx(Typography, { level: TypographyLevel.BodyXs, noWrap: true, className: className, children: shortName }) })) : (_jsx(Typography, { level: TypographyLevel.BodyXs, noWrap: true, className: className, children: shortName }));
};
